export default __webpack_public_path__ + "static/media/four_stars.d2bd54e2.svg";